import React from "react";

import { ArrowRightIcon as ArrowRight } from "@packages/ds";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";

import useDecodedParams from "Hooks/useDecodedParams";
import { nextWizardStep } from "Reducers/project/wizard";

import ListSteps from "../ListSteps";

import * as S from "./Intro.styles";

const Intro = ({ project }) => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const { organizationId, projectId } = useDecodedParams();

  const handleStart = e => {
    e?.preventDefault();
    dispatch(nextWizardStep({ organizationId, projectId }));
  };

  return (
    <S.Wrapper>
      <S.Content>
        <S.ImageContainer />

        <S.ProjectTitle tag="h2">
          {intl.formatMessage(
            { id: "wizard.intro.title" },
            {
              name: project?.title
            }
          )}
        </S.ProjectTitle>

        <p>{intl.formatMessage({ id: "wizard.intro.sentence" })}</p>

        <S.Footer>
          <S.FooterButton
            onClick={handleStart}
            variant="link"
            analyticId="wizard.intro.start"
          >
            {intl.formatMessage({ id: "wizard.intro.start" })}
            <ArrowRight />
          </S.FooterButton>
        </S.Footer>
      </S.Content>

      <ListSteps />
    </S.Wrapper>
  );
};

Intro.propTypes = {
  project: PropTypes.object
};

export default Intro;
